import React from 'react';

import { VideoPlayerMethods } from './video-player.type';

export function useVideoPlayer<T extends VideoPlayerMethods>(
  ref: React.ForwardedRef<VideoPlayerMethods>
) {
  const videoRef = React.useRef<T>(null);

  React.useImperativeHandle(ref, () => ({
    play: () => videoRef.current?.play?.(),
    pause: () => videoRef.current?.pause?.(),
  }));

  return {
    videoRef,
  };
}
